import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ConsultationRecordShell.module.css';

export type ConsultationStickyActionBarProps = {
  isDirty?: boolean;
  statusMessage?: string;
  statusError?: string;
  infoMessage?: string;
  /** Kept away from the primary actions so a destructive click is never a near-miss for Save. */
  destructiveAction?: React.ReactNode;
  children: React.ReactNode;
};

export const ConsultationStickyActionBar: React.FC<ConsultationStickyActionBarProps> = ({
  isDirty = false,
  statusMessage,
  statusError,
  infoMessage,
  destructiveAction,
  children,
}) => {
  const { t } = useTranslation(['consultations', 'common']);

  return (
    <section className={styles.stickyActionBar}>
      <div className={styles.actionLead}>
        {destructiveAction}
        <div className={styles.actionMessages}>
          {infoMessage ? <span className={styles.statusMessage}>{infoMessage}</span> : null}
          {isDirty ? (
            <span className={styles.dirtyIndicator}>
              {t('unsavedChanges', { defaultValue: 'Unsaved changes' })}
            </span>
          ) : null}
          {statusMessage ? <span className={styles.statusMessage}>{statusMessage}</span> : null}
          {statusError ? <span className={styles.dangerMessage}>{statusError}</span> : null}
        </div>
      </div>
      <div className={styles.actionButtons}>
        {children}
      </div>
    </section>
  );
};
